import { render, staticRenderFns } from "./PastPatientVisits.vue?vue&type=template&id=2c60116e&scoped=true"
import script from "./PastPatientVisits.vue?vue&type=script&lang=js"
export * from "./PastPatientVisits.vue?vue&type=script&lang=js"
import style0 from "./PastPatientVisits.vue?vue&type=style&index=0&id=2c60116e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60116e",
  null
  
)

export default component.exports